//Announcement bar above menu slider

document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector('.cc-announcement-slider');
  if (!slider) return;

  const slides = slider.querySelectorAll('.cc-announcement-slider__slide');
  const prevArrow = slider.querySelector('.cc-announcement-slider__nav--prev');
  const nextArrow = slider.querySelector('.cc-announcement-slider__nav--next');
  const autoRotate = slider.getAttribute('data-auto-rotate') === 'true';
  const sliderSpeed = parseInt(slider.getAttribute('data-slider-speed'), 10) * 1000 || 5000;

  let currentIndex = 0;
  let autoRotateInterval;

  function showSlide(index) {
    slides.forEach((slide, i) => {
      slide.style.opacity = '0';
      slide.style.display = 'none';
      slide.classList.remove('visible');
    });

    slides[index].style.display = 'block';
    setTimeout(() => {
      slides[index].style.opacity = '1';
      slides[index].classList.add('visible');
    }, 10); // Slight delay to allow opacity transition
  }

  function nextSlide() {
    currentIndex = (currentIndex + 1) % slides.length;
    showSlide(currentIndex);
  }

  function prevSlide() {
    currentIndex = (currentIndex - 1 + slides.length) % slides.length;
    showSlide(currentIndex);
  }

  function startAutoRotate() {
    stopAutoRotate(); // Clear any existing interval to avoid multiple intervals running.
    if (autoRotate && slides.length > 1) {
      autoRotateInterval = setInterval(nextSlide, sliderSpeed);
    }
  }

  function stopAutoRotate() {
    clearInterval(autoRotateInterval);
  }

  if (nextArrow) {
    nextArrow.addEventListener('click', () => {
      nextSlide();
      startAutoRotate(); // Restart the timer after manual interaction
    });
  }

  if (prevArrow) {
    prevArrow.addEventListener('click', () => {
      prevSlide();
      startAutoRotate(); // Restart the timer after manual interaction
    });
  }

  // Start the slider initially
  showSlide(currentIndex);
  startAutoRotate();
});

  
